<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Notification Role</h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="p-0" #tabsContainer>
  <mat-tab-group>
    <mat-tab label="Notification Role">
      <ng-template matTabContent>
        <app-notification-roles-edit [notification_role_id]="notification_role_id" (notification_role_id_changed)="notification_role_id = $event" (close_dialog)="onClose()" (scroll_to_top)="onScrollToTop()"></app-notification-roles-edit>
      </ng-template>
    </mat-tab>

    <mat-tab [label]="utils.getLangTerm('parent-child-sites-combined.plural', 'Sites')" *ngIf="notification_role_id && canManageSitesTab">
      <ng-template matTabContent>
        <app-notification-roles-sites [notification_role_id]="notification_role_id"></app-notification-roles-sites>
      </ng-template>
    </mat-tab>

    <mat-tab [label]="utils.getLangTerm('employees.plural', 'Employees')" *ngIf="notification_role_id && canManageEmployeesTab">
      <ng-template matTabContent>
        <app-notification-roles-users [notification_role_id]="notification_role_id"></app-notification-roles-users>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
